/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */

import axios from 'axios';
import * as CONSTANTS from './constants';

const DOMAIN = CONSTANTS.WEB_URL;

const myListUrls = {
  list: `${DOMAIN}/mylist.htm`,
  listUpdate: `${DOMAIN}/mylist/<<id>>.htm`,
  getListContacts: `${DOMAIN}/mylist/<<id>>/contact.htm?limit=<::limit>&pagination=<::pagination>&lastOwnedId=<::lastOwnedId>&lastOwnedIdUpdateTs=<::lastOwnedIdUpdateTs>&isSharedList=<::isSharedList>&teamId=<::teamId>`,
  listContacts: `${DOMAIN}/mylist/<<id>>/contact.htm`,
};

const purchaseUrls = {
  sync: `${DOMAIN}/purchase/contact/sync.htm`,
  async: `${DOMAIN}/purchase/contact/async.htm`,
};

export const URLS = {
  loginValidation: `${DOMAIN}/getMemberEntityWithSubscription.htm`,
  logout: `${DOMAIN}/j_spring_security_logout`,
  resendEmailConfirmation: `${DOMAIN}/verifyUserEmail.htm`,
  getFeatureFlags: `${DOMAIN}/memberattribute/getmemberattribute.htm?attributeId=FEATURE_FLAG`,
  savedSearch: `${DOMAIN}/searchByType/savedTemplates.htm?searchType=`,
  saveSearch: `${DOMAIN}/search/save.htm`,
  updateSavedSearch: `${DOMAIN}/search/template/name/`,
  deleteSavedSearch: `${DOMAIN}/search/template/`,
  myLeadsContactsInfo: `${DOMAIN}/my_leads/updateContacts.htm?type=<::type>&listId=<::listId>&page=<::page>&limit=<::limit>&dateFilter=<::dateFilter>`,
  myLeadsContactListCount: `${DOMAIN}/lists/getContactListCount.htm`,
  getContactListCountByIds: `${DOMAIN}/lists/getContactListCountByIds.htm`,
  companyNameWithDomain: `${DOMAIN}/autocomplete/companyNameWithDomain.htm?is_eu=`,
  companyNameWithDomainV2: `${DOMAIN}/autocomplete/companyNameWithDomainV2.htm`,
  companyKeyword: `${DOMAIN}/autocomplete/companyKeyword.htm`,
  technologies: `${DOMAIN}/autocomplete/technologies.htm`,
  getIndustrySuggestions: `${DOMAIN}/getIndustrySuggestions.htm?searchText=`,
  getDepartment: `${DOMAIN}/advanced/allDepartment.htm`,
  getLevel: `${DOMAIN}/advanced/allLevel.htm`,
  getLocation: `${DOMAIN}/autocomplete/location.htm`,
  searchResults: `${DOMAIN}/advanced/searchResults.htm`,
  companySearchResults: `${DOMAIN}/company-search/searchResults.htm`,
  checkEuCountry: `${DOMAIN}/checkForEU.htm`,
  purchaseContact: `${DOMAIN}/purchaseContact.htm?type=<::type>&now=<::now>&listId=<::listId>&oldListId=<::oldListId>&isEu=<::isEu>&exportType=<::exportType>&source=<::source>`,
  markAsInactive: `${DOMAIN}/markAsInactiveMasterContactByAdmin.htm`,
  deleteContacts: `${DOMAIN}/deleteContactsByAdmin.htm`,
  getAllUploadedEnricherList: `${DOMAIN}/bulk/getSeekerJobs.htm`,
  updatePassword: `${DOMAIN}/updatePassword.htm?`,
  checkCurrentPassword: `${DOMAIN}/checkCurrentPassword.htm?`,
  updateMemberTimeZone: `${DOMAIN}/updateMemberTimeZone.htm`,
  getSavedCard: `${DOMAIN}/getSavedCard.htm`,
  getSubscriptionPlans: `${DOMAIN}/getSubscriptionPlans.htm`,
  sendStripeTokenToServer: `${DOMAIN}/updateStripe.htm`,
  getTeamDetails: `${DOMAIN}/team.htm`,
  removeUser: `${DOMAIN}/team/block.htm`,
  teamInvite: `${DOMAIN}/team/invite.htm`,
  exportSelectedLeadsToZoho: `${DOMAIN}/exportSelectedLeadsToZoho.htm`,
  pipeDriveToken: `${DOMAIN}/auth/pipedrive/token.htm`,
  exportLeadsToCSV: `${DOMAIN}/exportLeadsToCSV.htm`,
  exportLeadsToCSVBulk: `${DOMAIN}/export/bulk/`,
  authorizeToHubspot: `${DOMAIN}/hubspot/authStatus.htm`,
  exportLeadsToHubspot: `${DOMAIN}/exportLeadsToHubspot.htm`,
  exportLeadsToPipedrive: `${DOMAIN}/exportLeadsToPipedrive.htm`,
  exportLeadsToOutReach: `${DOMAIN}/exportLeadsToOutReach.htm`,
  exportLeadsOutreachSequence: `${DOMAIN}/outreach/sequences.htm`,
  exportLeadsToMicrosoftDynamics: `${DOMAIN}/exportLeadsToMicrosoftDynamics.htm`,
  exportLeadsToMarketo: `${DOMAIN}/exportLeadsToMarketo.htm`,
  seekerBulkJobUpload: `${DOMAIN}/bulk/job/seeker.htm`,
  seekerBulkJobStop: `${DOMAIN}/bulk/jobs/stopJob.htm`,
  planSubscribe: `${DOMAIN}/subscribe.htm`,
  reportMarkAsInactive: `${DOMAIN}/reportAsInactiveMasterContact.htm`,
  getValidDomains: `${DOMAIN}/getValidDomains.htm`,
  getHubspotCalendarLink: `${DOMAIN}/getAccountOwnerCalendarLink.htm`,
  trialUser: {
    upgradeNow: `${DOMAIN}/requestUpgradeByTrialUser.htm`,
    updatePopupActivity: `${DOMAIN}/updatePopupActivity.htm`,
    isTeamMemberInvited: `${DOMAIN}/isTeamMemberInvited.htm`,
  },
  verifyTrialRequest: `${DOMAIN}/verifyTrialRequest.htm`,
  updatePaidUserWelcomePopupShown: `${DOMAIN}/updateWelcomePopupShown.htm`,
  updateMemberOnboardingInfo: `${DOMAIN}/updateMemberOnboardingInfo.htm`,
  hubspotEventPush: `${DOMAIN}/hubspotEventPush.htm`,
  getCompanyInfoById: `${DOMAIN}/getCompanyInfoById.htm`,
  getIndustrySectorsSuggestion: `${DOMAIN}/autocomplete/industrysectors.htm`,
  suppressionList: {
    getList: `${DOMAIN}/inclusionExclusionList/getLists.htm?type=`,
    getValidEntries: `${DOMAIN}/inclusionExclusionList/getValidEntries.htm`,
    saveList: `${DOMAIN}/inclusionExclusionList/saveList.htm`,
    enableDisableList: `${DOMAIN}/inclusionExclusionList/enableDisableList.htm`,
    deleteList: `${DOMAIN}/inclusionExclusionList/deleteList.htm`,
    downloadList: `${DOMAIN}/inclusionExclusionList/download.htm`,
  },
  technographicDemoRequest: `${DOMAIN}/technographicDemoRequest.htm`,
  companyExport: {
    exportSelectedCompaniesToCSV: `${DOMAIN}/exportSelectedCompaniesToCSV.htm`,
    exportBulkCompaniesToCSV: `${DOMAIN}/exportCompaniesToCSV.htm`,
  },
  salesgear: {
    authenticate: `${DOMAIN}/authenticateSalesgear.htm`,
    getUserDetail: `${DOMAIN}/getAuthenticatedSalesgearMember.htm`,
    validateMandatoryFields: `${DOMAIN}/export/salesgear/validate.htm`,
    exportToContact: `${DOMAIN}/export/salesgear.htm`,
    getAllSequence: `${DOMAIN}/seq/getAllSequence.htm`,
    getAllSequenceFolders: `${DOMAIN}/seq/getFolders.htm`,
    getFolderSeqeunceById: `${DOMAIN}/seq/getSequenceByFolder/<<folderId>>.htm`,
    getSharedSequence: `${DOMAIN}/seq/getSharedSequence.htm`,
  },
  concierge: {
    createList: `${DOMAIN}/conciergeList/createList.htm`,
    getLists: `${DOMAIN}/conciergeList/getLists.htm`,
  },
  crmIntegrations: {
    getAllStatus: `${DOMAIN}/crm/getAllStatus.htm`,
    connect: `${DOMAIN}/crm/connect.htm?crmType=<::crmType>`,
    disconnect: `${DOMAIN}/crm/disconnect.htm?crmType=<::crmType>`,
    getStatus: `${DOMAIN}/crm/getStatus.htm?crmType=<::crmType>`,
  },
  crmFieldMapping: `${DOMAIN}/crm/fieldMapping.htm?crmType=<::crmType>&exportType=<::exportType>&crmSettingsId=<::crmSettingsId>`,
  enrichmentSettings: `${DOMAIN}/crm/enrichmentConfig.htm?crmType=<::crmType>&crmSettingsId=<::crmSettingsId>`,
  crmExport: {
    export: `${DOMAIN}/crm/export.htm?crmType=<::crmType>&type=<::type>&source=<::source>&exportType=<::exportType>`,
    accountOwnershipMapping: `${DOMAIN}/crm/accountOwnershipMapping.htm?crmType=<::crmType>&type=<::type>&source=<::source>`,
  },
  userAnalytics: {
    emailReportForRecurring: `${DOMAIN}/usageanalytical/schedule.htm`,
    deleteRecurringMails: `${DOMAIN}/usageanalytical/<<mailId>>/schedule.htm`,
  },
  getMemberInfoUsingEmail: `${DOMAIN}/getMemberInfoUsingEmail.htm`,
  verifyLBTrialRequest: `${DOMAIN}/verifyLBTrialRequest.htm`,
  updateProfileData: `${DOMAIN}/updateProfileData.htm`,
  getEnrichmentLogs: `${DOMAIN}/crm/enrichmentLog.htm?crmType=<::crmType>&crmSettingsId=<::crmSettingsId>&from=<::from>&to=<::to>&page=<::page>&count=<::count>`,
  getEnrichmentLogsCount: `${DOMAIN}/crm/enrichmentLogCount.htm?crmType=<::crmType>&from=<::from>&to=<::to>&crmSettingsId=<::crmSettingsId>`,
  downloadEnrichmentLogs: `${DOMAIN}/crm/downloadEnrichmentLog.htm?crmType=<::crmType>&from=<::from>&to=<::to>&crmSettingsId=<::crmSettingsId>`,
  editTeamMember: `${DOMAIN}/team/edit.htm`,
  fetchCredits: `${DOMAIN}/fetchCredits.htm`,
  getPriceAmount: `${DOMAIN}/getPriceAmount.htm?credits=<::credits>`,
  getExtraCreditsPaymentDetail: `${DOMAIN}/getExtraCreditsPaymentDetail.htm?credits=<::credits>&phoneCredits=<::phoneCredits>`,
  buyAdditionalCredits: `${DOMAIN}/buyAdditionalCredits.htm`,
  updateBuyAdditionalCreditFailed: `${DOMAIN}/updateBuyAdditionalCreditFailed.htm`,
  getActiveMoreCreditsPlans: `${DOMAIN}/getActiveMoreCreditsPlans.htm?activeSubscriptionId=<::activeSubscriptionId>`,
  getUsageAnalytics: `${DOMAIN}/getUsageAnalytics.htm`,
  updateMemberEmail: `${DOMAIN}/updateMemberEmail.htm`,
  captureUserInterestInAdapt: `${DOMAIN}/captureUserInterestInAdapt.htm`,
  setUserPassword: `${DOMAIN}/setUserPassword.htm`,
  notifyEnterprisePlanInterest: `${DOMAIN}/notifyEnterprisePlanInterest.htm?notificationType=<::notificationType>`,
  savedSearchV2: `${DOMAIN}/savedsearches/search.htm?searchType=<::searchType>&limit=<::limit>&lastId=<::lastId>`,
  deleteSavedSearchV2: `${DOMAIN}/savedsearches/<<id>>/search.htm`,
  savedSearchNewContactCount: `${DOMAIN}/savedsearches/<<id>>/newlyAddedContactCount.htm?noOfDays=<::noOfDays>`,
  fileEnrichment: {
    getEntries: `${DOMAIN}/fileenrich/entry.htm?page=<::page>&limit=<::limit>`,
    uploadCSV: `${DOMAIN}/fileenrich/uploadandcreate.htm`,
    updateFieldMapping: `${DOMAIN}/fileenrich/fieldmapping.htm`,
  },
  updateEnrichmentSteps: `${DOMAIN}/updateEnrichmentSteps.htm`,
  saveEmailSearchPref: `${DOMAIN}/saveSearchCriteriaFlags.htm`,
  apiUsageAnalytics: `${DOMAIN}/getAPIUsageAnalytics.htm`,
  notifyMobileNumberInterest: `${DOMAIN}/notifyMobileNumberInterest.htm`,
  getIndustryClassification: `${DOMAIN}/advanced/industryClassificationCodes.htm`,
  exportToCSVV2: `${DOMAIN}/exportToCSV.htm`,
  myList: myListUrls,
  purchase: purchaseUrls,
  SFAuth: `${DOMAIN}/crm/salesforce/auth/status.htm`,
};

export const makeApi = (
  config,
  noCache = true,
  doCancelRequest,
  withCredentials = true,
  options = {},
) => {
  const { CancelToken } = axios;
  const { sendContentType = true } = options;
  config.method = config.method || 'GET';
  config.headers = {
    Accept: 'application/json',
    ...(sendContentType && { 'Content-Type': 'application/json' }),
  };

  if (noCache) config.headers['Cache-Control'] = 'no-cache';

  config.withCredentials = withCredentials;
  if (doCancelRequest !== undefined)
    config.cancelToken = new CancelToken(function executor(c) {
      doCancelRequest(c);
    });

  return axios(config)
    .then(response => {
      return response;
    })
    .catch(response => {
      if (
        (response.config !== undefined &&
          response.config.url !== undefined &&
          response.config.url.includes('j_spring_security_logout')) ||
        (response &&
          response.response !== undefined &&
          response.response.status === 401)
      ) {
        document.cookie = 'li=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        window.location.href = CONSTANTS.WEB_URL + CONSTANTS.BASE_LOGIN_URL;
      }

      return response;
    });
};

export default makeApi;
